import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'
import Typography, { FontWeights } from 'builder/styles/typography'

export const Container = styled.div`
  display: flex;
  gap: ${Spacing.S};
  background-color: ${Colors.Neutral5};
  padding: ${Spacing.S};
  border-radius: ${Spacing['2XS']};
  text-wrap: balance;
  align-items: center;

  ${Media.Phone`
    flex-direction: column;
    text-align: center;
    gap: ${Spacing.XS};
    padding: ${Spacing.S} ${Spacing.XS};
  `}
`
export const Text = styled.div`
  ${Typography.Caption};
  ${FontWeights.Regular};
  color: ${Colors.Neutral90};
`

export const Img = styled.img`
  width: auto;
  height: 32px;
  flex-shrink: 0;

  ${Media.Phone`
    height: 38px;
  `}
`
